import React from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import img from '../../assets/img/brand/goodybuddy_short.png';
import AddButton from 'components/Button/AddButton';

const BasicDetails = ({ user, navigate, id }) => {
  return (
    <Row className="justify-content-center align-items-stretch bg-red-200">
      {/* Left Card: Profile Image */}
      <Col md="4" sm="12" className="d-flex">
        <Card className="shadow flex-fill">
          <CardBody className="d-flex flex-column align-items-center justify-content-center">
            <img
              src={user?.profileImage||img}
              alt={`${user.firstName} ${user.lastName}`}
              className="rounded-circle mb-3 object-center object-cover"
              width="150"
              height="150"
            />
            <CardTitle tag="h2">
              {user.firstName} {user.lastName}
            </CardTitle>
          </CardBody>
        </Card>
      </Col>

      {/* Right Card: Details */}
      <Col md="8" sm="12" className="d-flex">
        <Card className="shadow flex-fill">
          <CardBody>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Email:</strong></Col>
              <Col md="8" sm="8">{user?.email}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Mobile:</strong></Col>
              <Col md="8" sm="8">{user?.mobileNo}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Date of Birth:</strong></Col>
              <Col md="8" sm="8">{new Date(user?.dob).toLocaleDateString('en-GB')}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Account Created On:</strong></Col>
              <Col md="8" sm="8">{new Date(user?.createdAt).toLocaleDateString('en-GB')}</Col>
            </Row>
            <Row className="mb-2">
              <Col md="4" sm="4"><strong>Type:</strong></Col>
              <Col md="8" sm="8">{user?.type}</Col>
            </Row>
            <div className="text-center mt-3">
              <div className="d-flex justify-content-between align-items-center">
                <AddButton title="Edit" onClick={() => navigate('/admin/user/edit/' + id)} />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default BasicDetails;
